<template>
  <object-form-structure
    v-if="objectUuid"
    :title="getTitle()"
    :layer="objectLayer"
    :form="form"
    @close="$emit('close')"
    :object-uuid="objectUuid"
    :object-coordinate="searchObjectField(this.objectData, 'geo_json')"
  >
    <v-expansion-panels v-model="panel" multiple id="form-fields" accordion>
      <v-expansion-panel :key="tab.code" v-for="tab in form.tabs">
        <v-expansion-panel-header>{{ tab.label }}</v-expansion-panel-header>
        <v-expansion-panel-content v-if="tab.type === 'form'">
          <v-layout wrap justify-space-between class="mx-5 my-2">
            <network-fields
              :key="field.id"
              v-for="field in tab.fields"
              :label="field.label_client ? field.label_client : field.label"
              :inputType="field.input_type"
              :value="getValueInObject(field.var_name)"
              :hide="field.hide"
              :size="field.size"
              :variable-name="field.var_name"
              :select-options="field.select_list_name"
            />
          </v-layout>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </object-form-structure>
</template>

<script>
import ObjectFormStructure from "@/components/Network/Forms/_Templates/ObjectFormStructure";
import NetworkFields from "@/components/Network/Forms/_Molecules/NetworkFields";
import { formsNetworkMixin } from "@/mixins/formsNetworkMixin";
export default {
  name: "ClosureAreaForm",

  components: { NetworkFields, ObjectFormStructure },

  mixins: [formsNetworkMixin]
};
</script>



// WEBPACK FOOTER //
// src/components/Network/Forms/ObjectForms/ClosureAreaForm.vue